const MIN_VALUE = 0.1;
const MAX_PERCENTS = 100;

export const getPercentFromDecimalRatio = (
  value: number,
  decimalsCount: number = 1,
) => {
  if (value === 0) return `${value}%`;

  const valueInPercents = value * MAX_PERCENTS;

  if (valueInPercents < MIN_VALUE) {
    return `< ${MIN_VALUE}%`;
  }

  if (valueInPercents % 1 !== 0) {
    const isValueInPercentsIsAboutHundred =
      Math.abs(valueInPercents - MAX_PERCENTS) < MIN_VALUE;

    if (isValueInPercentsIsAboutHundred) {
      return `≈${MAX_PERCENTS}%`;
    }

    return `${valueInPercents.toFixed(decimalsCount)}%`;
  }

  return `${valueInPercents}%`;
};

/**
 * Formats a decimal ratio into a percentage string with appropriate formatting
 *
 * @param value - Decimal ratio to be converted to percentage (0.5 becomes 50%)
 * @param decimalsCount - Number of decimal places to display (default: 1)
 * @returns Formatted percentage string with % symbol
 *
 * Special cases:
 * - Returns "0%" when value is 0
 * - Returns "< 0.1%" when percentage is below 0.1%
 * - Returns "≈100%" when percentage is approximately 100%
 * - Rounds to specified decimal places when result has fractional part
 * - Returns whole number when percentage has no fractional part
 */
